import { CheckIcon } from 'components/icons'
import classNames from 'helpers/class-names'
import { Dispatch, FC } from 'react'
import { TagColor } from 'types/tag-color'

interface Props {
  checked: boolean
  onChange: Dispatch<boolean>
  name: string
  checkboxClasses?: string
  value?: string
  disabled?: boolean
  color?: TagColor
  tabIndex?: number
}

export const Checkbox: FC<Props> = ({
  checked,
  onChange,
  name,
  checkboxClasses,
  value,
  disabled = false,
  color,
  tabIndex = 0,
}) => {
  const colorClass = color
    ? color !== 'default'
      ? `tag-${color}`
      : `tag`
    : 'gray'
  return (
    <label className="flex size-4 cursor-pointer items-center rounded bg-white outline-none focus-within:ring-2 focus-within:ring-info/75 focus-within:ring-offset-1">
      <div
        className={classNames(
          `inline-block size-4 rounded border border-${colorClass}`,
          { 'border-gray-100': !color },
          checked && `bg-${colorClass}`,
          { 'border-none text-white': checked },
          { 'cursor-not-allowed saturate-50': disabled },
          { 'bg-gray-50': !checked && disabled },
          { 'text-white/65': checked && disabled },
          checkboxClasses,
        )}>
        {checked && <CheckIcon />}
      </div>
      <input
        role="checkbox"
        className="sr-only"
        type="checkbox"
        name={name}
        value={value}
        checked={checked}
        disabled={disabled}
        onChange={(e) => onChange(e.target.checked)}
        tabIndex={tabIndex}
      />
    </label>
  )
}
